import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import styles from './navbar.module.scss';

interface SettingsNavLinkProps {
  showSettings: boolean;
  expanded: boolean;
  onClick: () => void;
}

const SettingsNavLink = ({
  expanded,
  onClick,
  showSettings,
}: SettingsNavLinkProps) => {
  if (!showSettings) {
    return <></>;
  }
  return (
    <NavLink
      className={classnames(
        'nav-link mb-2 mb-lg-0',
        styles.navLinks,
        { [styles.navLinkTitle]: expanded },
        { [styles.settings]: expanded }
      )}
      key="Settings"
      to="/settings/account"
      isActive={(_, location) => location.pathname.startsWith('/settings/')}
      data-testid={'settings'}
      data-cy={`navbar:settings-link`}
      onClick={onClick}
    >
      Settings
    </NavLink>
  );
};

export default SettingsNavLink;
